import RouterView from '@/page/main/DefaultRouterView'
import Disk from '@/page/disk/list'

export default {
  path: '/Disk',
  component: RouterView,
  children: [{
      path: 'List',
      meta: {
        type: ['disk', 'list'],
        title: '我的文件柜'
      },
      component: Disk
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/disk.js